import contractTerminationSubmitSuccessAlertDictionary from '@widgets/contract-termination-submit-success-alert/i18n/ru/contract-termination-submit-success-alert.dic.json';

export const contractTerminationSubmitSuccessAlert = {
  CONTRACT_TERMINATION_SUBMIT_SUCCESS_ALERT:
    contractTerminationSubmitSuccessAlertDictionary,
};

export const contractTerminationSubmitSuccessAlertNamespaces = [
  'CONTRACT_TERMINATION_SUBMIT_SUCCESS_ALERT',
];
